import { useEffect, useState } from "react";
import { useTranscriptionStore } from "../../store";

const ConnectionStatus = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [showDetails, setShowDetails] = useState(false);

  const { initializeApp, isInitialized, errors, settings } =
    useTranscriptionStore();

  useEffect(() => {
    const checkConnection = async () => {
      try {
        if (isInitialized) {
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }
      } catch (error) {
        setIsConnected(false);
      }
    };
    checkConnection();
  }, [isInitialized]);

  if (isConnected) {
    return null; // Don't show when connected
  }

  return (
    <div className="relative">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="bg-red-500/20 border border-red-500/30 text-red-300 px-3 py-2 rounded-lg text-xs flex items-center gap-2 hover:bg-red-500/30 transition-colors"
      >
        <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
        Connection Lost
      </button>

      {showDetails && (
        <div className="absolute top-full right-0 mt-2 bg-black/90 backdrop-blur-sm border border-red-500/20 rounded-lg p-3 text-xs text-red-200 min-w-[200px]">
          <div className="font-semibold mb-2">Backend Disconnected</div>
          <div className="text-red-300/80 mb-3">
            The Python backend is not responding. Some features may not work.
          </div>
          <button
            onClick={() => window.location.reload()}
            className="bg-red-600 hover:bg-red-700 px-3 py-1 rounded text-white text-xs transition-colors"
          >
            Reload App
          </button>
        </div>
      )}
    </div>
  );
};

export default ConnectionStatus;
